import { render } from "./Minicart.vue?vue&type=template&id=3ad40e5c&scoped=true"
import script from "./Minicart.vue?vue&type=script&lang=js"
export * from "./Minicart.vue?vue&type=script&lang=js"

import "@/assets/scss/_minicart.scss?vue&type=style&index=0&id=3ad40e5c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad40e5c"]])

export default __exports__